import { Injectable, signal } from '@angular/core';

/** Signal-driven visibility toggle for the profile overlay, mirroring ActionMenuService. */
@Injectable({ providedIn: 'root' })
export class ProfileDialogService {
    private readonly _isOpen = signal(false);
    readonly isOpen = this._isOpen.asReadonly();

    open(): void {
        this._isOpen.set(true);
    }

    close(): void {
        this._isOpen.set(false);
    }
}
